document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.video-faq-section');

  sections.forEach((section) => {
    const faqItems = section.querySelectorAll('.faq-item');

    faqItems.forEach((item) => {
      const trigger = item.querySelector('.faq-trigger');
      const answer = item.querySelector('.faq-answer');

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');

        // Close all other FAQs in this section
        faqItems.forEach((faq) => {
          if (faq !== item) {
            faq.classList.remove('active');

            const btn = faq.querySelector('.faq-trigger');
            const panel = faq.querySelector('.faq-answer');

            btn.setAttribute('aria-expanded', 'false');
            panel.style.maxHeight = null;
          }
        });

        // Toggle current FAQ
        if (isOpen) {
          item.classList.remove('active');
          trigger.setAttribute('aria-expanded', 'false');
          answer.style.maxHeight = null;
        } else {
          item.classList.add('active');
          trigger.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });

    // Recalculate heights on resize
    window.addEventListener('resize', () => {
      section.querySelectorAll('.faq-item.active').forEach((item) => {
        const answer = item.querySelector('.faq-answer');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      });
    });
  });
});